import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

const IS_MD_BREAKPOINT = 768
const IS_LG_BREAKPOINT = 1024

const { width } = useWindowSize()

export const isMobile = computed(() => {
    return width.value < IS_MD_BREAKPOINT
})
export const isDesktop = computed(() => {
    return !isMobile.value
})
export const md = computed(() => {
    return width.value >= IS_MD_BREAKPOINT
})
export const lg = computed(() => {
    return width.value >= IS_LG_BREAKPOINT
})
export const pageWidth = computed(() => {
    return width.value
})
